import { extractErrorMessage } from "@platform/api";

export const materializeSaveErrorMessage = (
  kind: "benefit" | "footnote",
  err: Error,
): string => {
  const label = kind === "footnote" ? "footnote" : "benefit field";
  return `Failed to save ${label}: ${extractErrorMessage(err)}`;
};
